<template>
	<div class="uupay-container">
    <UUPayBanner>
      <template v-slot:title>
        <div class="banner-title-uu">輕鬆支付</div>
      </template>
      <template v-slot:subtitle>
        <div class="home2-img"><img src="@/assets/uupay/images/logo_butterfly.png"> </div>
        輕鬆收款
      </template>
      <template v-slot:info>
        UUPay 適用於來自任何地方、任何行業和任何規模的企業的數字支付和財務管理平台.在香港和大灣區已經為超過10000家商戶提供電子支付服務.
      </template>
    </UUPayBanner>
    <UUPayMethod />

    <!-- 功能模块区域（多行多列） -->
    <section class="modules-section">
      <div class="container modules-section-container">
        <div class="row content-row">
          <div class="col-md-4">
            <div class="content">
              <div class="pos-content">
                <div class="title">智能POS收款機</div>
                <div class="subtitle">為增長業務而設的收款機</div>
              </div>
              <div class="pos-img">
                <div class="pos-img-bg">
                  <img src="@/assets/uupay/images/pos_machine_icon.png" alt="pos" style="width: 222px;margin-bottom: 10px;">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="content">
              <div class="pos-content">
                <div class="title">2合一收款機</div>
                <div class="subtitle">下單收款一機辦妥</div>
              </div>
              <div class="pos-img">
                <img src="@/assets/uupay/images/two_in_one_pos.png" alt="pos" class="img-fluid">
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="content">
              <div class="pos-content">
                <div class="title">二維碼支付</div>
                <div class="subtitle">靈活 低成本的收款方式</div>
              </div>
              <div class="pos-img">
                <img src="@/assets/uupay/images/pos_qrcode.png" alt="pos" class="img-fluid">
              </div>
            </div>
          </div>
          
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="content">
              <div class="pos-content">
                <div class="title">收款連結</div>
                <div class="subtitle">隨時隨地  一健付款</div>
              </div>
              <div class="pos-img">
                <img src="@/assets/uupay/images/pos_im.png" alt="pos" style="width:228px; height: 320px; margin-left: 2rem;">
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="content">
              <div class="pos-content">
                <div class="title">支付網關</div>
                <div class="subtitle">開拓你的網上業務</div>
              </div>
              <div class="pos-img justify-content-end">
                <img src="@/assets/uupay/images/pos_pay_detail2.png" alt="pos" class="img-fluid">
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="content">
              <div class="pos-content">
                <div class="title">後台服務</div>
                <div class="subtitle">隨時支持你的支付款服務</div>
              </div>
              <div class="pos-img justify-content-end" >
                <img src="@/assets/uupay/images/pos_order_list2.png" alt="pos" style="width: 300px;">
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>

    <UUPayHomeFeature />

    <!-- why us -->
    <section class="why-us-section">
      <div class="container">
        <div class="row">
          <div class="col-md-6 d-flex justify-content-center">
            <div>
              <img src="@/assets/uupay/images/why_us_channel.png" alt="" class="img-fluid">
            </div>
          </div>
          <div class="col-md-6">
            <div class="info">
              <div class="question">為什麼選擇我們？</div>
              <div class="d-flex">
                <div class="answer-icon"><img src="@/assets/uupay/icon/svg/simple.svg" alt=""></div>
                <div class="d-flex flex-column">
                  <div class="answer-title">簡單</div>
                  <div class="answer-detail">開戶步驟簡單方便一站式服務</div>
                </div>
              </div>
              <el-divider></el-divider>
              <div class="d-flex">
                <div class="answer-icon"><img src="@/assets/uupay/icon/svg/quick.svg" alt=""></div>
                <div class="d-flex flex-column">
                  <div class="answer-title">快捷</div>
                  <div class="answer-detail">即日過數為您的客戶提供即時線上線下支付方式</div>
                </div>
              </div>
              <el-divider></el-divider>
              <div class="d-flex">
                <div class="answer-icon"><img src="@/assets/uupay/icon/svg/transparent.svg" alt=""></div>
                <div class="d-flex flex-column">
                  <div class="answer-title">透明</div>
                  <div class="answer-detail">註冊開戶 0幾價出機沒有隱藏手續費</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <UUPayMerchant />
    <UUPayBannerContact :info="['收付無界 系統無縫', 'UUPay 為你推動業務']" />
    <UUPayFaqs />
  </div>
</template>
<script>
import UUPayHomeFeature from "@/components/uupayHomeFeature";
import UUPayBannerContact from "@/components/uupayBannerContact";
import UUPayFaqs from "@/components/uupayFaqs";
import UUPayMethod from "@/components/uupayMethod";
import UUPayMerchant from "@/components/uupayMerchant";
import UUPayBanner from "@/components/uupayBanner";

export default {
  name: 'UUPayPage',
  components: {
    UUPayHomeFeature,
    UUPayBannerContact,
    UUPayFaqs,
    UUPayMethod,
    UUPayMerchant,
    UUPayBanner
  },
  data() {
    return {
    }
  },

}
</script>
<style scoped>


.modules-section {
  margin: 100px 0;
}

@media (min-width: 1700px) {
  .modules-section-container {
    max-width: 1440;
  }
}

.modules-section .content {
  background-color: #f8f8f8;
  border-radius: 6px;
}
.modules-section .pos-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 4.5rem 0 2rem 0;
}
.modules-section .title {
  font-size: 30px;
  line-height: 100%;
  color: #21042e;
  margin-bottom: 1rem;
  font-weight: 600;
}
.modules-section .subtitle {
  font-size: 18px;
  line-height: 100%;
  color: #bc68a4;
}
.modules-section .pos-img {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
}
.modules-section .pos-img-bg {
  background-image: url('/static/pos_bg.png');
  background-position: center;  
  background-size: cover;      
  background-repeat: no-repeat;
  width: 186px;
  height: 320px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.modules-section .content-row {
  margin: 40px 0;
}

.why-us-section {
  background-color: #f8f8f8;
  padding: 121px 0;
}
@media (min-width: 1700px) {
  .why-us-section .container {
    max-width: 1440px;
  }
}

.why-us-section .info {
  width: 500px;
  background-color: #fff;
  border-radius: 6px;
  padding: 3rem;
}
.why-us-section .info .question {
  font-size: 30px;
  font-weight: 600;
  line-height: 40px;
  color: #9a307a;
  margin-bottom: 2.3rem;
}
.why-us-section .info .answer-title {
  font-weight: 500;
  font-size: 28px;
  line-height: 40px;
  color: #21042e;
  margin-bottom: 1rem;
}
.why-us-section .info .answer-detail {
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  color: #4d4d4d;
}
.why-us-section .info .answer-icon {
  margin: 0.3rem 0.6rem 0 0;

}
</style>


// WEBPACK FOOTER //
// src/views/uupayPage.vue